import { firestoreAction } from 'vuexfire'
import { routinesCollection } from '@/firebase/data'
import {currentUserId} from '@/firebase/firebase'
import { timestamp} from '@/firebase/firebaseHelpers'
import _ from 'lodash'
import Routine from '@/models/Routine'
import * as DateHelper from '@/helpers/date'

// import state from './_state'
// import mutations from './_mutations'
// import actions from './_actions'
// import getters from './_getters'


const routineDefaults = () => {
  return {
    title: '',
    datesRaw: '',
    startedOn: DateHelper.midnight(),
    frequency_count: 1,
    frequency_period: 'daily',
    paused: false,
    lastDateDone: null,
    lastSkipOn: null,
    schedule: '',
    finishedOn: null,
    schedule: ''
  }
}

export default {
  state: {
    routines: [],
    routineDataLoaded: false,
  },
  mutations: {
    setDataLoaded (state) {
      state.routineDataLoaded = true
    }
  },
  getters: {
    templatedRoutines: (state, getters) => _.map(_.filter(getters.allRoutinesEnitities, (entity) => entity.isNotFinished() && entity.templateId), 'routine'),
    routineDataLoaded: (state) => state.routineDataLoaded,
    urgentRoutinesAndDone: (state, getters) => _.sortBy(_.concat(getters.urgentRoutines, getters.doneTodayRoutines), 'id'),
    allRoutines: (state) => state.routines,
    finishedRoutines: (state) => _.filter(state.routines, (routine) => !!routine.finishedOn),
    allRoutinesEnitities: (state) => _.map(state.routines, (routine) => Routine(routine)),
    unfinishedActiveRoutinesEnitities: (state, getters) => _.filter(getters.allRoutinesEnitities, (entity) => entity.isUnfinishedButToday() && entity.isActive()),
    unfinishedPausedRoutinesEnitities: (state, getters) => _.map(_.filter(getters.allRoutinesEnitities, (entity) => entity.isUnfinishedButToday() && entity.isPaused()), 'routine'),
    dontHaveToDoRoutines: (state, getters) => _.map(_.filter(getters.unfinishedActiveRoutinesEnitities, (routine) => !routine.skippedToday() && routine.isDontHaveToDo()), 'routine'),
    couldDoRoutines: (state, getters) => _.map(_.filter(getters.unfinishedActiveRoutinesEnitities, (routine) => !routine.skippedToday() && routine.isCouldDo()), 'routine'),
    shouldDoRoutines: (state, getters) => _.map(_.filter(getters.unfinishedActiveRoutinesEnitities, (routine) => !routine.skippedToday() && routine.isShouldDo()), 'routine'),
    urgentRoutines: (state, getters) => _.map(_.filter(getters.unfinishedActiveRoutinesEnitities, (routine) => !routine.skippedToday() && routine.isUrgent()), 'routine'),
    activeUrgentRoutines: (state, getters) => _.filter(getters.urgentRoutines, (routine) => !routine.paused),
    skippedTodayRoutines: (state, getters) => _.map(_.filter(getters.unfinishedActiveRoutinesEnitities, (routine) => routine.skippedToday()), 'routine'),
    doneTodayRoutines: (state, getters) => _.map(_.filter(getters.getters.allRoutines, (routine) => routine.doneToday()), 'routine'),
    niceToDoRoutines: (state, getters) => {
      return _.sortBy(_.difference(getters.allRoutines, getters.urgentRoutines), (routine) => Routine(routine).urgency()).reverse()
    },
  },
  actions: {
    bindRoutines: firestoreAction(context => {
      // context contains all original properties like commit, state, etc
      // and adds `bindFirestoreRef` and `unbindFirestoreRef`
      // we return the promise returned by `bindFirestoreRef` that will
      // resolve once data is ready
      return context.bindFirestoreRef(
        'routines', routinesCollection.where('uid', '==', currentUserId())
        ).then(() => { context.commit('setDataLoaded') })
    }),
    ADD_ROUTINE (_, { routine }) {
      console.log(routine)
      const newRoutine = Object.assign(routineDefaults(), {
        uid: currentUserId(),
        createdAt: timestamp()
      }, routine)

      routinesCollection.add(newRoutine)
    },
    async UPDATE_ROUTINE (dummy, { routine, updateFields }) {
      console.log('routine', routine)
      console.log('updateFields', updateFields)
      console.log('updateFields.datesRaw', updateFields.datesRaw)

      if (updateFields.datesRaw) {
        console.log(updateFields.datesRaw)

        const max = _.max(_.map(updateFields.datesRaw.split(','), (d) => DateHelper.midnight(d)))
        updateFields.lastDateDone = max
      }


      routinesCollection.doc(routine.id).update(updateFields)
    },
    async DELETE_ROUTINE ({ commit }, { routine }) {
      const data = { routine: { ...routine} }

      console.info('DELETE_ROUTINE', routine)

      const reverse_detail = 'restore routine'
      const action = 'ADD_ROUTINE'

      const title = routine.title

      commit('SET_LAST_ACTION', { action, title, reverse_detail, data, time: new Date() })

      console.info('DELETE_ROUTINE', routine)
      routinesCollection.doc(routine.id).delete()
    },
  }
}
